"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Text = _interopRequireDefault(require("../Text"));

var _Theme = _interopRequireDefault(require("../Theme"));

var _Image = _interopRequireDefault(require("../Image"));

var _Button = _interopRequireDefault(require("../Button"));

var _Spinner = _interopRequireDefault(require("../Spinner"));

var _constant = require("./constant");

var _ErrorScreen = _interopRequireDefault(require("./ErrorScreen.proptypes"));

var ErrorScreenWrapper = _styledComponents.default.div.withConfig({
  displayName: "ErrorScreen__ErrorScreenWrapper",
  componentId: "sc-1tgooh4-0"
})(["display:flex;flex-direction:column;align-items:center;width:", ";margin:auto auto 0;padding:", ";"], function (_ref) {
  var theme = _ref.theme,
      width = _ref.width;
  return width || theme.space.XXXXLarge;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.space.standard;
});

var TextWrapper = _styledComponents.default.div.withConfig({
  displayName: "ErrorScreen__TextWrapper",
  componentId: "sc-1tgooh4-1"
})(["display:flex;flex-direction:column;align-items:center;width:", ";"], function (_ref3) {
  var width = _ref3.width;
  return width || _constant.WRAPPER_DEFAULT.mobile.width;
});

var ActionWrapper = _styledComponents.default.div.withConfig({
  displayName: "ErrorScreen__ActionWrapper",
  componentId: "sc-1tgooh4-2"
})(["width:", ";margin:0 auto auto;display:flex;flex-direction:", ";gap:16px;align-items:center;justify-content:center;"], function (_ref4) {
  var width = _ref4.width,
      isMobile = _ref4.isMobile;
  return width || isMobile ? _constant.WRAPPER_DEFAULT.mobile.width : _constant.WRAPPER_DEFAULT.desktop.width;
}, function (_ref5) {
  var isMobile = _ref5.isMobile;
  return isMobile ? 'column' : 'row-reverse';
});

var ImageWrapper = _styledComponents.default.div.withConfig({
  displayName: "ErrorScreen__ImageWrapper",
  componentId: "sc-1tgooh4-3"
})(["margin-bottom:", ";"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.space.small;
});

var SecondaryButtonWrapper = _styledComponents.default.div.withConfig({
  displayName: "ErrorScreen__SecondaryButtonWrapper",
  componentId: "sc-1tgooh4-4"
})([""]);

var ErrorScreen = function ErrorScreen(_ref7) {
  var title = _ref7.title,
      message = _ref7.message,
      theme = _ref7.theme,
      url = _ref7.url,
      width = _ref7.width,
      textWidth = _ref7.textWidth,
      placeHolderBackground = _ref7.placeHolderBackground,
      showButton = _ref7.showButton,
      showSecondaryButton = _ref7.showSecondaryButton,
      buttonText = _ref7.buttonText,
      secondaryButtonText = _ref7.secondaryButtonText,
      isLoading = _ref7.isLoading,
      handleOnClick = _ref7.handleOnClick,
      handleOnClickSecondary = _ref7.handleOnClickSecondary,
      accessible = _ref7.accessible,
      isMobile = _ref7.isMobile;
  return /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme,
    tabIndex: !accessible ? '-1' : '0'
  }, /*#__PURE__*/_react.default.createElement(ErrorScreenWrapper, {
    width: width
  }, /*#__PURE__*/_react.default.createElement(ImageWrapper, null, /*#__PURE__*/_react.default.createElement(_Image.default, {
    src: url,
    alt: _constant.IMAGE_NOT_FOUND,
    width: _constant.IMAGE.width,
    height: _constant.IMAGE.height,
    placeHolderBackground: placeHolderBackground
  })), /*#__PURE__*/_react.default.createElement(TextWrapper, {
    width: textWidth
  }, /*#__PURE__*/_react.default.createElement(_Text.default, {
    type: _constant.SIZE.normal,
    bold: true,
    textAlign: _constant.ALIGN.center,
    marginBottom: "tiny"
  }, title), /*#__PURE__*/_react.default.createElement(_Text.default, {
    type: _constant.SIZE.small,
    color: _constant.COLOR.greyDark,
    textAlign: _constant.ALIGN.center
  }, message))), /*#__PURE__*/_react.default.createElement(ActionWrapper, {
    width: width,
    isMobile: isMobile
  }, showButton && /*#__PURE__*/_react.default.createElement(_Button.default, {
    backgroundColor: "primary",
    cardIndex: 0,
    color: "default",
    handleClick: function handleClick() {
      if (isLoading) return;
      handleOnClick();
    },
    width: isMobile ? _constant.BTN_DEFAULTS.MOBILE_WIDTH : _constant.BTN_DEFAULTS.WIDTH,
    paddingLeft: _constant.BTN_DEFAULTS.PADDING_LEFT,
    paddingRight: _constant.BTN_DEFAULTS.PADDING_RIGHT
  }, isLoading ? /*#__PURE__*/_react.default.createElement(_Spinner.default, {
    color: "primaryLight",
    height: _constant.SPINNER_DEFAULTS.HEIGHT,
    width: _constant.SPINNER_DEFAULTS.WIDTH,
    strokeWidth: _constant.SPINNER_DEFAULTS.STROKE_WIDTH
  }) : buttonText), showSecondaryButton && /*#__PURE__*/_react.default.createElement(SecondaryButtonWrapper, null, /*#__PURE__*/_react.default.createElement(_Button.default, {
    cardIndex: 0,
    color: "primary",
    border: "primary",
    handleClick: function handleClick() {
      handleOnClickSecondary();
    },
    width: isMobile ? _constant.BTN_DEFAULTS.MOBILE_WIDTH : _constant.BTN_DEFAULTS.WIDTH,
    paddingLeft: _constant.BTN_DEFAULTS.PADDING_LEFT,
    paddingRight: _constant.BTN_DEFAULTS.PADDING_RIGHT
  }, secondaryButtonText))));
};

ErrorScreen.propTypes = _ErrorScreen.default.PropTypes;
ErrorScreen.defaultProps = _ErrorScreen.default.DefaultTypes;
var _default = ErrorScreen;
exports.default = _default;